import React from 'react';
import Description from '../description';
import CheckboxBlock from '../checkbox-block';
import EmailBlock from '../email-block';
import classes from '../../share-mockup-design-popup.scss';
const ShareMockup = ({
  isLimitedEdition
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.content
}, /*#__PURE__*/React.createElement(Description, null), /*#__PURE__*/React.createElement(CheckboxBlock, {
  isLimitedEdition: isLimitedEdition
}), /*#__PURE__*/React.createElement(EmailBlock, {
  isLimitedEdition: isLimitedEdition
}));
export default ShareMockup;